module.exports = __webpack_public_path__ + "static/foto_frente-a63d26bf7782def3ce6a572b1f8edbdf.jpg";